import { render, staticRenderFns } from "./RollDiceWindow.vue?vue&type=template&id=418c7247"
import script from "./RollDiceWindow.vue?vue&type=script&lang=js"
export * from "./RollDiceWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports